import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, CardBody, Input, InputGroup, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Spinner } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ownerDetails.css';
import BoatOwnerDetailsView from './BoatOwnerDetailsView';
import { getAllProfiles } from '../../api/boat_owner/boatOwnerApi';
import { getNewStockCountByBoatOwnerId } from '../../api/stock/index';
import { getOrderCountByBoatOwnerId } from '../../api/order/orderApi';
import vesseldefault from '../../assets/images/vesseldefault.jpg';

const BoatOwners = () => {
  const [initialOwners, setInitialOwners] = useState([]); // Store original data
  const [filteredOwners, setFilteredOwners] = useState([]); // Store filtered data
  const [filter1DropdownOpen, setFilter1DropdownOpen] = useState(false);
  const [filter2DropdownOpen, setFilter2DropdownOpen] = useState(false);
  const [filter1, setFilter1] = useState('All');
  const [filter2, setFilter2] = useState('All');
  const [show, setShow] = useState(false);
  const [selectedOwner, setSelectedOwner] = useState(null);
  const [loading, setLoading] = useState(true);

  // Fetch all profiles and their orders/newStock counts
  const fetchStockData = async () => {
    setLoading(true);
    try {
      const response = await getAllProfiles();
      const profiles = response.data.data || [];

      console.log(profiles);

      // Fetch orders and newStock for each owner
      const enrichedProfiles = await Promise.all(
        profiles.map(async (owner) => {
          try {
            const [orderResponse, stockResponse] = await Promise.all([
              getOrderCountByBoatOwnerId(owner._id),
              getNewStockCountByBoatOwnerId(owner._id),
            ]);
            console.log(owner);
            return {
              ...owner,
              orders: orderResponse.data?.count || 0,
              newStock: stockResponse.data?.count || 0,
            };
          } catch (error) {
            console.error(`Error fetching data for owner ${owner._id}:`, error);
            return { ...owner, orders: 0, newStock: 0 }; // Fallback values
          }
        })
      );

      setInitialOwners(enrichedProfiles);
      setFilteredOwners(enrichedProfiles); // Initialize filtered data
    } catch (error) {
      console.error('Error fetching profiles:', error);
      setInitialOwners([]);
      setFilteredOwners([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStockData();
  }, []);

  const handleOwnerClick = (owner) => {
    setSelectedOwner(owner);
    setShow(true);
  };

  const toggleFilter1 = () => setFilter1DropdownOpen((prevState) => !prevState);
  const toggleFilter2 = () => setFilter2DropdownOpen((prevState) => !prevState);

  // Apply filters to initialOwners and update filteredOwners
  const applyFilters = (filter1Value, filter2Value) => {
    let filtered = [...initialOwners];

    // Filter 1: Orders
    if (filter1Value === 'Orders > 400') {
      filtered = filtered.filter((owner) => owner.orders > 400);
    } else if (filter1Value === 'Orders <= 400') {
      filtered = filtered.filter((owner) => owner.orders <= 400);
    }

    // Filter 2: New Stock
    if (filter2Value === 'New Stock > 4') {
      filtered = filtered.filter((owner) => owner.newStock > 4);
    } else if (filter2Value === 'New Stock <= 4') {
      filtered = filtered.filter((owner) => owner.newStock <= 4);
    }

    setFilteredOwners(filtered);
  };

  const handleFilter1Select = (filterValue) => {
    setFilter1(filterValue);
    applyFilters(filterValue, filter2);
  };

  const handleFilter2Select = (filterValue) => {
    setFilter2(filterValue);
    applyFilters(filter1, filterValue);
  };

  const toggleModal = () => {
    setShow(!show);
    if (show) setSelectedOwner(null);
  };

  return (
    <div style={{ minHeight: '100%', marginTop: '100px', padding: '30px' }}>
      <Container fluid>
        <div className="d-flex justify-content-between align-items-center mb-4">
          <h4 className="mb-0">Boat Owners</h4>
          <div className="d-flex align-items-center">
            <Dropdown
              style={{ marginRight: '15px' }}
              isOpen={filter2DropdownOpen}
              toggle={toggleFilter2}
              className="mr-2"
            >
              <DropdownToggle
                caret
                color="light"
                className="border rounded"
                style={{ borderRadius: '80px' }}
              >
                {filter2 === 'All' ? 'Filter: New Stock' : filter2}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleFilter2Select('All')}>
                  All
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleFilter2Select('New Stock > 4')}
                >
                  New Stock 4
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleFilter2Select('New Stock <= 4')}
                >
                  New Stock = 4
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <Dropdown
              style={{ marginRight: '15px' }}
              isOpen={filter1DropdownOpen}
              toggle={toggleFilter1}
              className="mr-2"
            >
              <DropdownToggle
                caret
                color="light"
                className="border rounded"
                style={{ borderRadius: '80px' }}
              >
                {filter1 === 'All' ? 'Filter: Orders' : filter1}
              </DropdownToggle>
              <DropdownMenu>
                <DropdownItem onClick={() => handleFilter1Select('All')}>
                  All
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleFilter1Select('Orders > 400')}
                >
                  Orders 400
                </DropdownItem>
                <DropdownItem
                  onClick={() => handleFilter1Select('Orders <= 400')}
                >
                  Orders = 400
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
            <InputGroup style={{ width: '200px' }}>
              <Input
                placeholder="Search"
                className="rounded2"
              />
            </InputGroup>
          </div>
        </div>
        {loading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ minHeight: '200px' }}
          >
            <Spinner color="primary" />
          </div>
        ) : filteredOwners.length === 0 ? (
          <div
            className="text-center"
            style={{
              minHeight: '200px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            <h5>No boat owners found.</h5>
          </div>
        ) : (
          <Row>
            {filteredOwners.map((owner, index) => (
              <Col
                xs="12"
                sm="6"
                md="4"
                lg="3"
                key={owner.id || index}
                className="mb-4"
              >
                <Card>
                  <CardBody className="text-left">
                    <div className="d-flex">
                      <img
                        style={{ margin: '0px 18px' }}
                        src={owner.profileImage || vesseldefault}
                        className="avatar-placeholder mb-3"
                        alt="Owner"
                      />
                      <div style={{ marginTop: '5px' }}>
                        <span
                          style={{
                            fontWeight: 'bold',
                            fontSize: '24px',
                            cursor: 'pointer',
                          }}
                          className="mb-1"
                          onClick={() => handleOwnerClick(owner)}
                        >
                          {owner.firstName} {owner.lastName}
                        </span>
                        <div className="d-flex justify-content-left align-items-center mb-2">
                          <span
                            style={{
                              position: 'relative',
                              fontSize: '24px',
                              marginRight: '8px',
                              bottom: '2px',
                            }}
                            className="star-icon mr-1"
                          >
                            ★
                          </span>
                          <span style={{ fontSize: '18px' }}>
                            {owner.rating || 'N/A'}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{ fontSize: '18px', marginTop: '25px' }}
                      className="d-flex justify-content-center align-items-center"
                    >
                      <span className="mr-3">
                        Orders{' '}
                        <span
                          style={{ fontWeight: 'bold', marginLeft: '20px' }}
                        >
                          {owner.orders || 0}
                        </span>
                      </span>
                      <span
                        style={{ margin: '0px 35px' }}
                        className="text-muted"
                      >
                        {' '}
                        |{' '}
                      </span>
                      <span className="ml-3">
                        New Stock{' '}
                        <span
                          style={{ fontWeight: 'bold', marginLeft: '20px' }}
                        >
                          {owner.newStock || 0}
                        </span>
                      </span>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            ))}
          </Row>
        )}
        <style jsx>{`
          .avatar-placeholder {
            width: 80px;
            height: 80px;
            background-color: #e0e0e0;
            border-radius: 50%;
            object-fit: cover;
          }
          .star-icon {
            color: #ffd700;
            font-size: 1.2rem;
          }
          .card {
            transition: transform 0.2s;
          }
          .card:hover {
            transform: translateY(-5px);
          }
        `}</style>
        <BoatOwnerDetailsView
          isOpen={show}
          details={selectedOwner}
          toggle={toggleModal}
        />
      </Container>
    </div>
  );
};

export default BoatOwners;